<template>
  <div>已跳转仓储实时大屏页面，请在新页面查看</div>
</template>
<script>
import global from '@/api/global'
export default {
  data () {
    return {

    }
  },
  created () {
    this.tiaoZhuan()
  },
  methods: {
    tiaoZhuan () {
      window.open(global.baseUrl + '/#/bulkCargo')
    }
  }
}
</script>
<style>

</style>
